import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Announcement, AnnouncementTranslation, AnnouncementService } from '../../services/announcement.service';

/**
 * Baner ogłoszeń systemowych.
 * mode="public" — ekran logowania (endpoint anonimowy, dismiss w localStorage + licznik),
 * mode="my"     — po zalogowaniu (ogłoszenia targetowane, dismiss per user).
 */
@Component({
  selector: 'app-announcement-banner',
  templateUrl: './announcement-banner.component.html',
  styleUrls: ['./announcement-banner.component.scss']
})
export class AnnouncementBannerComponent implements OnInit {
  @Input() mode: 'public' | 'my' = 'public';

  announcements: Announcement[] = [];

  constructor(
    private announcementService: AnnouncementService,
    private translate: TranslateService
  ) {}

  // Tłumaczenie wg języka UI, fallback: en → treść bazowa (null).
  private pickTranslation(a: Announcement): AnnouncementTranslation | null {
    const tr = a.translations || {};
    const lang = (this.translate.currentLang || this.translate.getDefaultLang() || 'en').toLowerCase();
    if (tr[lang] && tr[lang].content) { return tr[lang]; }
    if (tr['en'] && tr['en'].content) { return tr['en']; }
    return null;
  }

  displayTitle(a: Announcement): string | null {
    const t = this.pickTranslation(a);
    return t ? (t.title || null) : a.title;
  }

  displayContent(a: Announcement): string {
    const t = this.pickTranslation(a);
    return t ? t.content : a.content;
  }

  ngOnInit() {
    const source = this.mode === 'public'
      ? this.announcementService.getPublic()
      : this.announcementService.getMy();

    source.subscribe(
      res => {
        let list = (res && res.announcements) || [];
        if (this.mode === 'public') {
          const dismissed = this.announcementService.getLocalDismissedIds();
          list = list.filter(a => dismissed.indexOf(a.id) === -1);
        }
        this.announcements = list;
      },
      () => { this.announcements = []; }
    );
  }

  dismiss(a: Announcement) {
    this.announcements = this.announcements.filter(x => x.id !== a.id);
    const call = this.mode === 'public'
      ? this.announcementService.dismissPublic(a.id)
      : this.announcementService.dismiss(a.id);
    call.subscribe(() => {}, () => {});
  }

  trackById(index: number, a: Announcement) {
    return a.id;
  }
}
